<template>
    <component :is="`${capitalizeFirstLetter(locale)}About`"/>
</template>

<script>
import NzAbout from '~/components/about/NzAbout'
import AusAbout from '~/components/about/AusAbout'

export default {
    components: {
        NzAbout,
        AusAbout
    },
    head () {
        const title = 'About Truestock'

        return {
            title,
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: title
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: title
                }
            ]
        }
    }
}
</script>
